import { useState } from "react";
import ticketApi from "../api/ticketApi";
import { loadingAtom } from "../store";
import { useAtom } from "jotai";

interface FetchOptions<T, E> {
  onError?: (err: E) => any;
  onSuccess?: (data: T, status?: boolean) => any;
}

const useTicket = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [error, setError] = useState<string | null>(null);
  const [, setIsLoading] = useAtom(loadingAtom);

  const fetch = async (id: number, email:string, options: FetchOptions<any, string>) => {
    const { onError, onSuccess } = options;
    setLoading(true);
    setIsLoading(true);
    const result = await ticketApi.getTicketDetails(id, email);
    setLoading(false);
    setIsLoading(false);
    if (!result.ok) {
      setError(result.originalError.message);
      return onError?.(result.originalError.message);
    }

    if (result.data.data.length === 0) {
      setError("Cannot find details of ticket with ID: " + id);
      return onError?.("Cannot find details of ticket with ID: " + id);
    }
    setData(result.data.data);
    onSuccess?.(result.data.data, result.data.success);
  };

  return { loading, data, error, fetch };
};

export default useTicket;
